
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
import { Heading } from '@/components/Heading'
import { TipGood, TipBad } from '@/components/Tip'
import { CodeSample } from '@/components/CodeSample'
const Layout = _Layout;
const meta = {
  "id": "testingapp",
  "title": "Test Apps",
  "sidebar_label": "Testing App"
};
const slug = 'testingapp';
const tableOfContents = [{
  "title": "PRODUCTION:",
  "slug": "production",
  "children": [{
    "title": "Using Your Android App",
    "slug": "using-your-android-app",
    "children": []
  }, {
    "title": "Using/Accessing Your iOS App",
    "slug": "using-accessing-your-i-os-app",
    "children": []
  }]
}, {
  "title": "Requirements for testing",
  "slug": "requirements-for-testing",
  "children": []
}, {
  "title": "Important Note:",
  "slug": "important-note",
  "children": []
}, {
  "title": "Things that are not testable",
  "slug": "things-that-are-not-testable",
  "children": []
}, {
  "title": "SANDBOX:",
  "slug": "sandbox",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p><strong parentName="p">{` Testing the app has two different methods based on the stage you are `}</strong>{` `}</p>
    <_Heading level={2} id={"production"} nextElement={{
      "type": "paragraph"
    }}>PRODUCTION:</_Heading>
    <p>{`This is a live mode. You can use the preview domain under tradly.co for you to see your website. or add your `}<_Link href="/settings/domain" passHref><a>{`custom domain`}</a></_Link>{`. Suitable for those seeking a straightforward and quick launch approach.`}</p>
    <_Heading level={3} id={"using-your-android-app"} nextElement={{
      "type": "jsx"
    }}>Using Your Android App</_Heading>
    <img src="/img/googleplay.svg" alt="signup-page" width="200" />
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Download Link:  `}<a parentName="li" {...{
          "href": "https://play.google.com/store/apps/details?id=tradly.platform"
        }}>{`Tradly Platform Android`}</a></li>
      <li parentName="ul">{`You can download the app using the above link on your android device and enter your tenant ID (also called as appname or project) app name.  `}</li>
    </ul>
    <_Heading level={3} id={"using-accessing-your-i-os-app"} nextElement={{
      "type": "jsx"
    }}>Using/Accessing Your iOS App</_Heading>
    <img src="/img/appstore.svg" alt="signup-page" width="200" />
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Download Link:  `}<a parentName="li" {...{
          "href": "https://apps.apple.com/app/id1524190804"
        }}>{`Tradly Platform iOS`}</a></li>
      <li parentName="ul">{`You can download the app using the above link on your iOS device and enter your tenant ID or app name. `}</li>
    </ul>
    <_Heading level={2} id={"requirements-for-testing"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>Requirements for testing</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`SuperAdmin account.`}</li>
      <li parentName="ol">{`Download an Android App OR`}</li>
      <li parentName="ol">{`Download an iOS app OR`}</li>
    </ol>
    <p>{`4.`}<a parentName="p" {...{
        "href": "https://github.com/TRADLY-PLATFORM/"
      }}>{`Fork open-source apps here`}</a></p>
    <_Heading level={2} id={"important-note"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Important Note:</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`In order to submit a listing, you must first register as a user. So, it’s a 2-level stage. Not all users would need it, but a seller would need it. 
-When there are no categories created in the SuperAdmin panel, you will find the homepage empty as well. And you can’t view listings, as you need to navigate through categories. 
-When there are no accounts(called “stores” in the fashion marketplace) and your marketplace is new, you will not find widgets(follow store/accounts) on the home page. Also, you cannot follow stores. Hence, the social feed will be empty. `}</li>
      <li parentName="ul">{`When there are no promotions created in your SuperAdmin panel, you will not find them on the app home page. So, again, it will feel empty. `}</li>
      <li parentName="ul">{`Your searches will not work if there are no listings. `}</li>
      <li parentName="ul">{`You cannot use the chat function if there are no listings, as chats are initiated through listings `}</li>
    </ul>
    <p>{`Hence, spend time registering dummy users, opening accounts/stores, submitting listings, etc. If you want to skip all the steps, you can simply use ‘tradlysocial’ as a tenant without superadmin access and experience the front-end app. `}</p>
    <_Heading level={2} id={"things-that-are-not-testable"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Things that are not testable</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`3rd party tool settings, such as branch and firebase, as these require app build changes. And you will get it when we provide white label app building. `}</li>
      <li parentName="ul">{`App Icons `}</li>
    </ul>
    <_Heading level={2} id={"sandbox"} nextElement={{
      "type": "paragraph"
    }}>SANDBOX:</_Heading>
    <p>{`The Sandbox mode mobile app has been decommissioned as of July 20, 2022. Sandbox apps are moved to production apps. The Sandbox superadmin has been decommissioned as of Nov 23, 2022. `}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
